// fe/src/pages/Lecture.tsx

import React from "react";
import { useParams } from "react-router-dom";
import LectureView from "../components/LectureView";

export default function Lecture() {
  const { id } = useParams<{ id?: string }>(); // Get ID from the URL parameters

  if (!id) {
    return <p>Lecture ID is required</p>;
  }

  return <LectureView id={id} />; // Render the LectureView component with the ID
}